export const DEFAULT_EVENT_PAGE_SIZE = 10;
